import {
  BookOpenCheck,
  Building2,
  CarFront,
  ClipboardCheck,
  FileText,
  Gavel,
  Landmark,
  Scale,
  UserRoundCheck,
  type LucideIcon,
} from "lucide-react";

export type SourceCard = {
  title: string;
  body: string;
  icon: LucideIcon;
};

export const sourceCards: SourceCard[] = [
  {
    title: "Insolvências e PER",
    body: "Deteta processos de insolvência, PER e PEAP que podem comprometer entregas, garantias ou reembolsos.",
    icon: Scale,
  },
  {
    title: "Dados da empresa",
    body: "Confirma NIF, CAE, estado, antiguidade e morada para validar se a atividade é compatível com comércio automóvel.",
    icon: Building2,
  },
  {
    title: "Obrigações do stand",
    body: "Verifica se a informação obrigatória na venda de usados está presente: preço, garantia, matrícula, ano e registos anteriores.",
    icon: CarFront,
  },
  {
    title: "Publicações MJ",
    body: "Consulta publicações oficiais, contas anuais, atos societários e estrutura de sócios e gerentes via MJ.ENGINO.PT.",
    icon: FileText,
  },
  {
    title: "Sócios e gerentes",
    body: "Cruza gerentes identificados via MJ com citações editais no Citius, assinalando homónimos para validação.",
    icon: UserRoundCheck,
  },
  {
    title: "Dívidas públicas",
    body: "Cruza listas públicas de devedores na Autoridade Tributária e Segurança Social.",
    icon: Landmark,
  },
  {
    title: "Processos cíveis",
    body: "Sinaliza ações cíveis como ré, requerida ou executada. Um processo isolado não implica, por si, condenação.",
    icon: Gavel,
  },
  {
    title: "Livro de Reclamações",
    body: "Apresenta sinais públicos e estatísticas agregadas, sem acesso ao conteúdo privado das reclamações.",
    icon: BookOpenCheck,
  },
  {
    title: "Citações editais",
    body: "Identifica sinais de incontactabilidade quando o tribunal não consegue localizar a entidade.",
    icon: ClipboardCheck,
  },
];
